import { Avatar, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, getLocalValue, IsSmallScreen, LoacalVariables, MasterPages, Method } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions, IPermission } from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import imag from '../../images/1.jpg'
import { IInfoColumns, WSInfocard } from "../../Components/View/WSInfocard";
export const DoctorDetails: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const { add, edit, remove, view } = getPermissions("doctors"); // role permissions for this page
    const userId=getLocalValue(LoacalVariables.UserId);
    useEffect(()=>{

        async function getDetails() {
            const response=await callAPI('DoctorProfile',Method.GET,null,userId)
        }

    },[])
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/doctor/edit/${row?.id}`)
        }

    };


    const columns: IColumns[] = [

        {
            header: "Full Name",
            fieldName: "fullName",
            type: "default",
            //  sortable: true
        },
        {
            header: "Email",
            fieldName: "email",
            tooltip: true,
            type: "default",
        },
        {
            header: "Phone",
            fieldName: "phoneNumber",
            tooltip: true,
            isHide: isMobile,
            type: "default",
        },
        {
            header: "Created On",
            fieldName: "createdAt",
            isHide: isMobile,
            type: "date",
        },
        {
            header: "Updated On",
            fieldName: "updatedAt",
            isHide: isMobile,
            type: "date",
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
        },

    ];
    const detailsColumns: IInfoColumns[] = [
        {

            fieldName: "fullName",
            type: "none",
            label: "FullName",

        },
        {

            fieldName: "fullName",
            type: "none",
            label: "FullName",

        },
        // {
        //     header: "Email",
        //     fieldName: "email",
        //     tooltip: true,
        //     type: "default",
        // },
        // {
        //     header: "Phone",
        //     fieldName: "phoneNumber",
        //     tooltip: true,

        //     type: "default",
        // },
        // {
        //     header: "Created On",
        //     fieldName: "createdAt",
        //     isBoderRadious: true,
        //     type: "date",
        // },
        // {
        //     header: "Updated On",
        //     fieldName: "updatedAt",
        //     isBoderRadious: true,
        //     type: "date",
        // },

        // {
        //     header: "Actions",
        //     fieldName: "actions",
        //     type: "action",
        //     actions: [edit ? "Edit" : undefined].filter(Boolean),
        //     actionCallback: (action, row) => handleAction(action, row),
        // },


    ];
    const handleClick = () => {
        navigate('/doctor/add')
    }

    const transFormData = (data: any) => {
        if (data) {
            data.map((item: any) => {
                item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
            })
            return data
        }
    }
    const data: any = {
        fullName: 'Sishanglal'
    }
    return (
        <>
            <Grid sx={{ position: "relative", mt: 5 }}>
                {/* Card */}
                <Grid
                    sx={{
                        backgroundColor: "white",
                        borderRadius: 2,
                        p: 2,
                        boxShadow: 1,
                        mt: 0, // Give space for Avatar
                    }}
                >
                    {/* Avatar - half outside the top of the card */}
                    <Avatar
                        src={imag}
                        alt="Profile"
                        sx={{
                            width: 80,
                            height: 80,
                            position: "absolute",
                            top: -40,
                            left: "50%",
                            transform: "translateX(-50%)",
                            border: "3px solid white",
                            overflow: "hidden",
                            '& img': {
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                // transform: 'scale(0.85)', // Zoom out effect
                                transformOrigin: 'center center',
                            },
                        }}
                    />


                    {/* Content below avatar */}
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        direction="column"
                        mt={4} // Space to push content below avatar
                    >
                        <Typography fontWeight="bold" sx={{ color: "#7D79C2", fontSize: "0.875rem" }}>
                            {getLocalValue(LoacalVariables.Name)}
                        </Typography>
                        {/* <Typography color="textSecondary">{`uiyuiyiiu`}</Typography> */}
                    </Grid>
                    <Grid
                        item container
                        spacing={2}>
                            <Grid sm={12} sx={{padding:2}} mt={2}>
                        <WSInfocard column={detailsColumns} data={data} header="Basic Information" />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>

        </>
    )
})